export default {
	auth : false,
    token_r: localStorage.getItem('access_token_r') || null,
    sessionTemp: null,
	lateralShow: true, // oculto= true, mostar = false
	profile: {},
}
